import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { PriceInput } from 'bricks';

import { getCorrectedValues } from './helpers';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function RangeFilterInputsStateless({
  min,
  max,
  valueFrom,
  valueTo,
  onValueChange,
  onInputFocus,
  onInputBlur /* isMobile, */,
}) {
  return (
    <div className={cx('prices')}>
      <PriceInput
        value={valueFrom || null}
        onChange={(value) => onValueChange({ valueFrom: value })}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        placeholder={`${min}`}
        tabIndex={0}
        className={cx('price', 'priceFrom')}
      />
      <PriceInput
        value={valueTo || null}
        onChange={(value) => onValueChange({ valueTo: value })}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        placeholder={`${max}`}
        tabIndex={0}
        className={cx('price', 'priceTo')}
      />
    </div>
  );
}

RangeFilterInputsStateless.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  valueFrom: PropTypes.number,
  valueTo: PropTypes.number,
  onValueChange: PropTypes.func,
  onInputFocus: PropTypes.func,
  onInputBlur: PropTypes.func,
  /* isMobile: PropTypes.bool, */
};

/**
 * Stateful version of RangeFilterInputs, used to enhance user experience
 * by keeping all the changes at bay when user writes in it
 * works exactly as stateless when not focused,
 * and as a normal PriceInput with no limits when focused
 */
export default class RangeFilterInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /** calculate valueFrom and valueTo based on incoming props */
      ...getCorrectedValues(props),
      isFocused: false,
    };
    this.switchTimeout = null;
  }

  static getDerivedStateFromProps(nextProps, { isFocused }) {
    if (!isFocused) {
      return getCorrectedValues(nextProps);
    }
    return null;
  }

  handleFocus = () => {
    clearTimeout(this.switchTimeout);
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.switchTimeout = setTimeout(() => this.setState({ isFocused: false }), 0);
  };

  /**
   * newValues has following format: { valueFrom, valueTo }
   * either one of them may be undefined
   *
   * NOTE: to avoid undefined value assigned, do not use destructuring operator
   */
  handleValueChange = (newValues) => {
    const { onValueChange, min, max } = this.props;

    /**
     * Use raw value data when changing local state
     */
    this.setState(newValues);

    /**
     * as for the global value, we need correct data
     * for input - fetch filled in valueFrom by using values kept in state
     * and overriding them with provided newValues
     * ---
     * do not apply limit, as user manually entered some values
     * he will see the max value but we will keep real value in mind
     */
    onValueChange(
      getCorrectedValues({ ...this.state, ...newValues, min, max }, { skipLimit: true }),
    );
  };

  render() {
    const { min, max, isMobile } = this.props;
    const { valueFrom, valueTo } = this.state;
    return (
      <RangeFilterInputsStateless
        /** pass down props as is */
        {...{ min, max, isMobile }}
        /** pass down overridden state */
        {...{ valueFrom, valueTo }}
        onInputFocus={this.handleFocus}
        onInputBlur={this.handleBlur}
        onValueChange={this.handleValueChange}
      />
    );
  }
}

RangeFilterInputs.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  valueFrom: PropTypes.number,
  valueTo: PropTypes.number,
  onValueChange: PropTypes.func,
  isMobile: PropTypes.bool,
};
